'use client';

import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { JobResponse } from '@/lib/types';
import { LazyImage } from '@/components/LazyImage';

export default function GalleryPickerModal({
  onSelect,
  onClose,
}: {
  onSelect: (job: JobResponse) => void;
  onClose: () => void;
}) {
  const [jobs, setJobs] = useState<JobResponse[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .listJobs('completed', 60, 0)
      .then((j) => setJobs(j.filter((x) => x.images?.length)))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div
      className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 animate-fadeIn"
      onClick={onClose}
    >
      <div
        className="bg-[var(--bg-elevated)] rounded-xl max-w-4xl w-full max-h-[80vh] overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-[var(--border-subtle)]">
          <h2 className="text-lg font-semibold">Select image</h2>
          <button onClick={onClose} className="btn btn-ghost h-8 px-3 text-sm">
            Close
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">
          {loading ? (
            <div className="text-center text-[var(--text-muted)] py-16">Loading…</div>
          ) : jobs.length === 0 ? (
            <div className="text-center text-[var(--text-muted)] py-16">No images in gallery</div>
          ) : (
            <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-5 gap-3">
              {jobs.map((job) => (
                <button
                  key={job.job_id}
                  onClick={() => onSelect(job)}
                  className="aspect-square rounded-lg overflow-hidden bg-[var(--bg-surface)] hover:ring-2 hover:ring-[var(--accent)] transition-all cursor-pointer"
                >
                  <LazyImage
                    src={api.getThumbnailUrl(job.images[0])}
                    fallbackSrc={api.getImageUrl(job.images[0])}
                    alt={job.prompt}
                    className="w-full h-full"
                  />
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
